import RiskCompliances from './RiskCompliances';
export default RiskCompliances;